let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("itSVE")).then(() => parcelRequire('4kcS5'));